import type { AceConversation, CraveDocSubmission, ExternalApply, JSTAceConversationResult, JSTCraveDocSubmissionResult, JSTExternalApplyResult, JSTModalScreen, JSTOpenModalResult, JSTViewJobResult, ViewJob } from './JSTModalScreen';

import TypedNativeModules from '../internal/TypedNativeModules';

export function openModal(modalScreen: ViewJob, from: string | null): Promise<JSTViewJobResult>;
export function openModal(modalScreen: AceConversation, from: string | null): Promise<JSTAceConversationResult>;
export function openModal(modalScreen: CraveDocSubmission, from: string | null): Promise<JSTCraveDocSubmissionResult>;
export function openModal(modalScreen: ExternalApply, from: string | null): Promise<JSTExternalApplyResult>;
export function openModal(modalScreen: JSTModalScreen, from: string | null): Promise<JSTOpenModalResult | void>;
export async function openModal(
    modalScreen: JSTModalScreen,
    from: string | null,
): Promise<void | JSTViewJobResult | JSTAceConversationResult | JSTCraveDocSubmissionResult | JSTExternalApplyResult | JSTOpenModalResult> {
    return await TypedNativeModules.RNJSTNavigator?.openModal?.(
        modalScreen,
        from,
    );
}
